import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT
var ossroot = process.env.OSSI_Path;


//获取列表数据
export const getCstagreementListData = (params) => {
  return axios.get(root + '/order/cstagreement/list', {params: params})
}

//获取列表数据 新版页面
export const getCstagreementListDataNew = (params, noloading) => {
  return axios.get(root + '/order/cstagreement/listnew', {params: params, noloading: noloading})
}


//删除行
export const cstagreementDeleteData = (params) => {
  return axios.post(root + '/order/cstagreement/remove', qs.stringify(params))
}

export const createmachiningOrder= (params) => {
  return axios.post(root + '/order/cstagreement/createmachiningOrder', qs.stringify(params))
}

//获取某一行的明细数据
export const getCstagreementDetail = (params) => {
  return axios.get(root + '/order/cstagreement/detail', {params: params})
}

export const detailERPSerial = (params) => {
  return axios.get(root + '/order/cstagreement/detailERPSerial', {params: params})
}


//保存某一行的数据
export const saveCstagreementData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/order/cstagreement/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/order/cstagreement/save', qs.stringify(params))
  }
}

export const updateExpressFee = (params) => {
  return axios.post(root + '/order/cstagreement/updateExpressFee', qs.stringify(params))
}


//保存某一行的数据
export const updatejiagong = (params) => {
  return axios.post(root + '/order/cstagreement/updatejiagong', qs.stringify(params))
}


//获取某一行的明细数据
export const getJxcformdetailGetList = (params) => {
  return axios.post(root + '/order/jxcformdetail/getList', qs.stringify(params))
}
export const getJxcformdetailGetListGroupguid = (params) => {
  return axios.post(root + '/order/jxcformdetail/getListGroupguid', qs.stringify(params))
}
export const updatePackagesize = (params) => {
  return axios.post(root + '/order/jxcformdetail/updatePackagesize', qs.stringify(params))
}


//更改对账状态 1表示已对账，0或者空表示未对账
export const updateDuiZhang = (params) => {
  let config = {
    timeout: 1000 * 60 * 2
  };   //添加请求
  return axios.post(root + '/order/jxcformdetail/updateDuiZhang', qs.stringify(params), config)
}

//删除行
export const jxcformdetailDeleteData = (params) => {
  return axios.post(root + '/order/jxcformdetail/remove', qs.stringify(params))
}

export const getJxcformdetailCost = (params) => {
  return axios.post(root + '/order/jxcformdetail/listnew2', qs.stringify(params))
}
//取消订单
export const cstagreementUpdateData = (params) => {
  return axios.post(root + '/order/cstagreement/toVoidStatus', qs.stringify(params))
}
//确认退货
export const tuiHuoUpdateData = (params) => {
  return axios.post(root + '/order/cstagreement/tuiHuoStatus', qs.stringify(params))
}
//查询仓库
export const jxcstorelist = (params) => {
  return axios.post(root + '/set/jxcstore/listbyipd', qs.stringify(params))
}

//获取某一行的明细数据（销售单明细）
export const getDetail = (params) => {
  return axios.get(root + '/order/jxcformdetail/detail', {params: params})
}

export const listSimple = (params) => {
  return axios.get(root + '/order/cstagreement/listSimple', {params: params})
}


//确认退货
export const returnGoodsUpdate = (params) => {
  return axios.post(root + '/order/cstagreement/returnGoodsUpdate', qs.stringify(params))
}
//仓库岗退货申请
export const cangKuGoodsUpdate = (params) => {
  return axios.post(root + '/order/cstagreement/cangKuGoodsUpdate', qs.stringify(params))
}
//仓库岗退货申请
export const cangKuShuLiangGoodsUpdate = (params) => {
  return axios.post(root + '/order/cstagreement/cangKuShuLiangGoodsUpdate', qs.stringify(params))
}

//退钱
export const updateaLiRefund = (params) => {
  return axios.post(root + '/recharge/rechargerecord/aLiRefund', qs.stringify(params))
}

//打印订单
export const printing = (params) => {
  return axios.post(root + '/order/cstagreement/salesOrder', qs.stringify(params))
}

//是否打印过订单
export const checkprinting = (params) => {
  return axios.post(root + '/order/printlog/list', qs.stringify(params))
}

//采购单保存
export const buyodersave = (params) => {
  return axios.post(root + '/order/purchaseorder/save', qs.stringify(params))
}

//与供应商系统的单点登录清单
export const ssoBuyWeb = (params) => {
  return axios.post(root + '/order/purchaseorder/ssoBuyWeb', qs.stringify(params))
}

//采购单删除
export const buyoderremove = (params) => {
  return axios.post(root + '/order/purchaseorder/remove', qs.stringify(params))
}

//修改供应商
export const updatePcustomer = (params) => {
  return axios.post(root + '/order/cstagreement/updatePcustomer', qs.stringify(params))
}

//订单数量
export const countlist = (params) => {
  return axios.post(root + '/order/cstagreement/countlist', qs.stringify(params))
}

export const printingbuy = (params) => {
  return axios.post(root + '/order/purchaseorder/buyOrderdetail', qs.stringify(params))
}

export const lensfrombad = (params) => {
  return axios.post(root + '/order/purchaseorder/lensfrombad', qs.stringify(params))
}

export const initialSSO = (params) => {
  return axios.post(root + '/order/purchaseorder/initialSSO', qs.stringify(params))
}


export const updatecostprice4FN = (params) => {
  return axios.post(root + '/order/purchaseorder/updatecostprice4FN', qs.stringify(params))
}
export const updatecostprice4FNorder = (params) => {
  return axios.post(root + '/order/purchaseorder/updatecostprice4FNorder', qs.stringify(params))
}

export const SSObuyOrder = (params, ssotoken) => {
  return axios.post(root + '/order/purchaseorder/SSObuyOrder', qs.stringify(params), {ssotoken: ssotoken})
}

export const SSOrelatedOrder = (params, ssotoken) => {
  return axios.post(ossroot + '/order/purchaseorder/SSOrelatedOrder', qs.stringify(params), {ssotoken: ssotoken})
}


//添加留言
export const updateliuyan = (params) => {
  return axios.post(root + '/order/cstagreement/updateliuyan', qs.stringify(params))

}

//跟新采购单
export const updatebuyorder = (params) => {
  return axios.post(root + '/order/purchaseorder/update', qs.stringify(params))
}

//跟新采购单
export const updateFastbuyorder = (params) => {
  return axios.post(root + '/order/purchaseorder/updateFast', qs.stringify(params))
}
export const updateFastFrame = (params) => {
  return axios.post(root + '/order/purchaseorder/updateFastFrame', qs.stringify(params))
}


//显示采购单详货品详情页面
export const buyorderdetail = (params) => {
  return axios.post(root + '/order/purchaseorder/getsalesOrder', qs.stringify(params))
}

//查询加工单
export const machiningOrder = (params) => {
  return axios.post(root + '/order/cstagreement/machiningOrder', qs.stringify(params))
}


//根据供应商和客户编号获取分组数据
export const getGroupByCustomerAndPcustomer = (params) => {
  return axios.post(root + '/order/cstagreement/getGroupByCustomerAndPcustomer', qs.stringify(params))
}


//获得商品采购单明细数据
export const buyorderdetaillist = (params) => {
  return axios.post(root + '/order/purchaseorder/buydetailedit', qs.stringify(params))
}


//获得供应商明细
export const getpcustomerserial = (params) => {
  return axios.post(root + '/order/purchaseorder/getpcustomerserial', qs.stringify(params))
}

//根据供应商和客户编号获取分组数据
export const chaifenOrder = (params) => {
  return axios.post(root + '/order/cstagreement/chaifenOrder', qs.stringify(params))
}

//采购单直接采购保存
export const buyodersavedetail = (params) => {
  return axios.post(root + '/order/purchaseorder/savedetail', qs.stringify(params))
}
//获取相同供应商、门店
export const identicalstore = (params) => {
  return axios.post(root + '/order/cstagreement/identicalstore', qs.stringify(params))
}

//合并订单
export const hebingOrder = (params) => {
  return axios.post(root + '/order/cstagreement/hebingOrder', qs.stringify(params))
}

//修改订单的仓库的信息
export const updatecangku = (params) => {
  return axios.post(root + '/order/cstagreement/updateCangku', qs.stringify(params))
}
//修改订单的仓库的信息
export const finishing = (params) => {
  return axios.post(root + '/order/cstagreement/finishing', qs.stringify(params))
}
//扫码加工完成
export const piliangfinishing = (params) => {
  return axios.post(root + '/order/cstagreement/piliangfinishing', qs.stringify(params))
}

//修改坏件单的状态
export const updateBrokenparks = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/updateBrokenparks', qs.stringify(params))
}
//修改坏件单的状态
export const changeBrokenparks = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/changeBrokenparks', qs.stringify(params))
}

//获得当前订单的付款方式
export const refundList = (params) => {
  return axios.post(root + '/recharge/rechargerecord/refundList', qs.stringify(params))
}

//根据选择的退款方式退款
export const returngoodssave = (params) => {
  return axios.post(root + '/recharge/rechargerecord/returngoodssave', qs.stringify(params))
}

//计算价格
export const calculatePrice = (params) => {
  return axios.post(root + '/order/cstagreement/countprice', qs.stringify(params))
}

//计算价格
export const ispsq = (params) => {
  return axios.post(root + '/set/machinecoupon/ispsq', qs.stringify(params))
}

//修改供应商
export const updategongying = (params) => {
  return axios.post(root + '/order/cstagreement/updategongying', qs.stringify(params))
}

//确认发货
export const comfirefahuo = (params) => {
  return axios.post(root + '/order/cstagreement/comfirefahuo', qs.stringify(params))
}

//订单成本价比对
export const priceComparison = (params) => {
  let config = {
    timeout: 1000 * 60 * 5
  };   //添加请求头
  return axios.post(root + '/order/cstagreement/priceComparison', qs.stringify(params), config)
}


//二次发货
export const ercifahuo = (params) => {
  return axios.post(root + '/order/cstagreement/ercifahuo', qs.stringify(params))
}
//驳回退货
export const cancelTuihuoOrder = (params) => {
  return axios.post(root + '/order/cstagreement/cancelTuihuoOrder', qs.stringify(params))
}

//修改成本价
export const updatecostprice = (params) => {
  return axios.post(root + '/order/purchaseorder/updatecostprice', qs.stringify(params))
}

//多次发货
export const multipleShipments = (params) => {
  return axios.post(root + '/order/cstagreement/multipleShipments', qs.stringify(params))
}
//扫快递单号发货
export const scanningfahuo = (params) => {
  return axios.post(root + '/order/cstagreement/scanningfahuo', qs.stringify(params))
}
//拣货完成
export const pickingUp = (params) => {
  return axios.post(root + '/order/cstagreement/pickingUp', qs.stringify(params))
}

//退运费
export const freightRefund = (params) => {
  return axios.post(root + '/order/cstagreement/freightRefund', qs.stringify(params))
}
//客服发起采购
export const kefufaqicaigou = (params) => {
  return axios.post(root + '/order/purchaseorder/kefufaqicaigou', qs.stringify(params))
}
//仓库跟踪单查询
export const trackSelect = (params) => {
  return axios.post(root + '/order/purchaseorder/trackSelect', qs.stringify(params))
}
//自动调整订单数量
export const adjustNumber = (params) => {
  return axios.post(root + '/order/purchaseorder/adjustNumber', qs.stringify(params))
}
//镜架、镜片到货情况
export const glassesArrival = (params) => {
  return axios.post(root + '/order/cstagreement/glassesArrival', qs.stringify(params))
}
//工作量
export const workload = (params) => {
  return axios.post(root + '/files/otherform/workload', qs.stringify(params))
}
export const workload2 = (params) => {
  return axios.post(root + '/files/otherform/workload2', qs.stringify(params))
}
export const workload3 = (params) => {
  return axios.post(root + '/files/otherform/workload3', qs.stringify(params))
}
export const workloaddetail = (params) => {
  return axios.post(root + '/files/otherform/workloaddetail', qs.stringify(params))
}

export const workloadgroupGlasses = (params) => {
  return axios.post(root + '/files/otherform/workloadgroupGlasses', qs.stringify(params))
}
export const workloadGlasses = (params) => {
  return axios.post(root + '/files/otherform/workloadGlasses', qs.stringify(params))
}
export const workloadSet = (params) => {
  return axios.post(root + '/files/otherform/workloadSet', qs.stringify(params))
}
//客服岗-待配送数量
export const pushcount = (params) => {
  return axios.post(root + '/order/cstagreement/pushcount', qs.stringify(params))
}
//客服岗-待配送列表
export const tobedelivered = (params) => {
  return axios.post(root + '/order/cstagreement/tobedelivered', qs.stringify(params))
}
//客服岗-待配送选择配送员、加急、期望时间
export const updatepushorder = (params) => {
  return axios.post(root + '/order/cstagreement/updatepushorder', qs.stringify(params))
}
export const updateStatus = (params) => {
  return axios.post(root + '/order/cstagreement/updateStatus', qs.stringify(params))
}

export const updateDetailbyunitguid = (params) => {
  return axios.post(root + '/order/jxcformdetail/update', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/csagreement.js